import React from 'react';
import PropTypes from 'prop-types';

export const getCurrencySymbol = (currency) => {
  switch (currency) {
  case 'EUR':
    return '€';
  case 'GBP':
    return '£';
  case 'SEK':
    return 'kr';
  case 'DKK':
    return 'kr';
  default:
    return '£';
  }
};

const ProductPrice = ({
  value,
  currency,
  priceStyle,
  oldPrice,
}) => (
  <div className={priceStyle}>
    {`${getCurrencySymbol(currency)}${parseFloat(value).toFixed(2)}`}
    {oldPrice && (oldPrice !== value) && (<span>{`${getCurrencySymbol(currency)}${parseFloat(oldPrice).toFixed(2)}`}</span>)}
  </div>
);

ProductPrice.propTypes = {
  value: PropTypes.number,
  currency: PropTypes.string,
  priceStyle: PropTypes.shape({}),
  oldPrice: PropTypes.string,
};

ProductPrice.defaultProps = {
  value: 0,
  currency: 'GBP',
  priceStyle: {},
  oldPrice: '',
};

export default ProductPrice;
